var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#578CAD"
    },
    d: "M98.17,471.424c-1.592,0-3.202-0.452-4.629-1.398c-3.864-2.559-4.921-7.768-2.361-11.633 l30.56-46.125c2.56-3.864,7.769-4.922,11.633-2.36c3.864,2.559,4.921,7.768,2.361,11.633l-30.56,46.125 C103.559,470.103,100.889,471.424,98.17,471.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#578CAD"
    },
    d: "M413.829,471.424c-2.721,0-5.388-1.322-7.004-3.758l-30.559-46.125 c-2.559-3.864-1.502-9.072,2.362-11.633c3.863-2.562,9.072-1.502,11.633,2.36l30.557,46.125c2.56,3.864,1.504,9.072-2.36,11.633 C417.03,470.972,415.422,471.424,413.829,471.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#578CAD"
    },
    d: "M256,471.423c-4.635,0-8.393-3.757-8.393-8.393v-46.124c0-4.636,3.758-8.393,8.393-8.393 c4.636,0,8.393,3.757,8.393,8.393v46.125C264.393,467.666,260.635,471.423,256,471.423z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A5D74"
    },
    d: "M310.774,91.317V61.334c0-11.462-9.294-20.758-20.757-20.758h-68.035 c-11.465,0-20.757,9.296-20.757,20.758v29.983H310.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M239.887,40.576h-17.905 c-11.465,0-20.757,9.296-20.757,20.758v29.983h17.905V61.334C219.132,49.873,228.423,40.576,239.887,40.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90C8EC"
    },
    d: "M392.607,213.312L342.2,93.866c-1.224-2.902-4.068-4.787-7.217-4.787H177.015 c-3.149,0-5.993,1.886-7.217,4.787l-50.406,119.445c-0.406,0.964-0.617,2-0.617,3.046v58.763c0,4.326,3.507,7.834,7.834,7.834 H385.39c4.326,0,7.834-3.507,7.834-7.834v-58.763C393.224,215.312,393.013,214.275,392.607,213.312z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#578CAD"
    },
    cx: 256.002,
    cy: 195.225,
    r: 34.017
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M136.681,275.12v-58.763c0-1.046,0.209-2.082,0.617-3.046 l50.406-119.445c1.224-2.902,4.068-4.787,7.217-4.787h-17.905c-3.149,0-5.993,1.886-7.217,4.787l-50.406,119.445 c-0.406,0.964-0.617,2-0.617,3.046v58.763c0,4.326,3.507,7.834,7.834,7.834h17.905C140.188,282.954,136.681,279.447,136.681,275.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M239.887,195.225c0-15.687,10.622-28.887,25.064-32.818 c-2.853-0.778-5.852-1.2-8.952-1.2c-18.789,0-34.018,15.232-34.018,34.018s15.23,34.016,34.018,34.016 c3.1,0,6.099-0.422,8.952-1.199C250.51,224.111,239.887,210.911,239.887,195.225z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#578CAD"
    },
    d: "M334.279,272.882H47.627C21.323,272.882,0,294.205,0,320.51v31.75 c0,11.464,9.292,20.757,20.757,20.757h470.488c11.462,0,20.756-9.293,20.756-20.757v-31.75c0-26.305-21.324-47.628-47.629-47.628 L334.279,272.882"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M17.905,352.26v-31.75c0-26.305,21.323-47.628,47.627-47.628 H47.627C21.323,272.882,0,294.205,0,320.51v31.75c0,11.464,9.292,20.757,20.757,20.757h17.905 C27.197,373.017,17.905,363.724,17.905,352.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9737"
    },
    d: "M461.837,331.343H50.162c-4.635,0-8.393-3.757-8.393-8.393s3.758-8.393,8.393-8.393h411.675 c4.636,0,8.393,3.757,8.393,8.393C470.23,327.585,466.473,331.343,461.837,331.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A5D74"
    },
    d: "M404.757,397.267c0,11.463-9.293,20.757-20.757,20.757H127.999c-11.463,0-20.757-9.294-20.757-20.757 v-4.611c0-11.466,9.294-20.759,20.757-20.759h256c11.464,0,20.757,9.293,20.757,20.759v4.611H404.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M125.149,397.267v-4.611c0-11.466,9.294-20.759,20.757-20.759 H128c-11.463,0-20.757,9.293-20.757,20.759v4.611c0,11.463,9.294,20.757,20.757,20.757h17.905 C134.443,418.024,125.149,408.73,125.149,397.267z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.1ecb263974f1d17b7aa9fda811afd563.svg";
export { ForwardRef as ReactComponent };